const CANCELLED_STATUS = "cancelled";

export interface TimeoffRequest {
  leaveStatus?: string | null;
  [key: string]: unknown;
}

export interface TimeoffRequestsByStatus {
  all?: TimeoffRequest[];
  [status: string]: TimeoffRequest[] | undefined;
}

export const isCancelledRequest = (request?: TimeoffRequest | null): boolean =>
  request?.leaveStatus?.toLowerCase?.() === CANCELLED_STATUS;

/**
 * The admin leaveRequests endpoints return an `all` bucket that still contains
 * cancelled requests, so they show up on both the All and the Cancelled tab.
 * Cancelled belongs on the Cancelled tab only — drop it from `all`.
 *
 * Entries without a `leaveStatus` are left untouched, so the grouped shape the
 * overlapping-requests filter returns (`all` holding companies, not requests)
 * passes through unchanged.
 *
 * Use this for what the tabs render and count. Keep passing the raw `all` list
 * to the request details view, which pages through every request by `requestId`
 * and would otherwise land on the wrong row when opening a cancelled request.
 */
export const excludeCancelledFromAll = (
  requestsByStatus?: TimeoffRequestsByStatus | null
): TimeoffRequestsByStatus => {
  if (!requestsByStatus) return {};
  if (!Array.isArray(requestsByStatus.all)) return requestsByStatus;

  return {
    ...requestsByStatus,
    all: requestsByStatus.all.filter((request) => !isCancelledRequest(request)),
  };
};

export default excludeCancelledFromAll;
